<template>
  <div class="item-card">
    <div class="card-title">创意分类</div>
    <div class="card-content">
      <ul class="modal-form">
        <li class="form-item">
          <span class="form-label" style="padding-top: 6px">创意包：</span>
          <div class="form-value">
            <div class="list-wrap">
              <ul class="data-list">
                <el-button class="add-btn" icon="el-icon-plus" @click="addCreativeClassify">新增创意包</el-button>
                <li
                  :class="['data-item', item.itemId === curItemId ? 'cur' : '']"
                  v-for="(item, index) of showList"
                  :key="item.itemId"
                  @click="selectClassifyItem(item)"
                >
                  <span>创意分类{{ index + 1 }}</span>
                  <el-dropdown trigger="click" size="small" @command="(type) => handleCommand(item, type)">
                    <i class="el-icon-more dot-icon"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="del" v-show="dataList.length > 1">删除</el-dropdown-item>
                      <el-dropdown-item command="copy">复制</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
              </ul>
              <div class="list-footer">
                <span class="list-length">{{ dataList.length }}/20</span>
                <div class="show-more">
                  <span v-show="!showMore" @click="showMore = true">更多<i class="el-icon-arrow-down"></i></span>
                  <span v-show="showMore" @click="showMore = false">收起<i class="el-icon-arrow-up"></i></span>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label" style="padding-top: 10px">创意分类：</span>
          <div class="form-value">
            <el-cascader
              v-model="curClassifyItem.industry_id"
              :options="industryList"
              :props="{
                value: 'industryId',
                label: 'industryName',
                emitPath: false,
              }"
              style="width: 240px"
              :disabled="curClassifyItem.isPackage"
            ></el-cascader>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label" style="padding-top: 6px">创意标签：</span>
          <div class="form-value">
            <div class="tag-wrap">
              <div class="tag-header">
                <el-input
                  placeholder="每个不超过10个字，空格分隔"
                  style="width: 240px"
                  v-model="inputTagStr"
                  :disabled="curClassifyItem.isPackage"
                ></el-input>
                <el-button
                  class="input-btn"
                  style="margin: 0 auto 0 10px"
                  @click="addWrods"
                  type="text"
                  :disabled="curClassifyItem.isPackage"
                  >添加</el-button
                >
                <span class="input-btn" @click="checkHasClassify">选择已有创意标签包</span>
              </div>
              <div class="tag-table">
                <div class="table-item">
                  <div class="table-header">
                    <span class="header-text">已选</span>
                    <el-button
                      class="header-text"
                      style="color: rgba(24, 144, 255, 1); cursor: pointer"
                      @click="clearAll"
                      type="text"
                      :disabled="curClassifyItem.isPackage"
                      >清除</el-button
                    >
                  </div>
                  <div class="table-content">
                    <div class="content-item" v-for="item of curClassifyItem.ad_keywords" :key="item">
                      {{ item }}<span @click="delItem(item)" v-show="!curClassifyItem.isPackage" class="close-btn">×</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label" style="padding-top: 6px">标签包名称：</span>
          <div class="form-value">
            <el-input
              type="text"
              placeholder="请填写"
              maxlength="10"
              show-word-limit
              style="width: 224px"
              v-model="curClassifyItem.creative_name"
              :disabled="curClassifyItem.isPackage"
            ></el-input>
          </div>
        </li>
      </ul>
      <div class="button-wrap" style="text-align: right">
        <el-button type="primary" @click="saveClassify" v-show="!curClassifyItem.isPackage">保存为创意标签包</el-button>
        <el-button type="primary" @click="copyToNew" v-show="curClassifyItem.isPackage">复制当前创意标签包到新建</el-button>
      </div>
    </div>

    <checked-modal
      title="选择创意标签包"
      :tableConf="tableConf"
      :tableData="tableData"
      ref="checkedClassifyModalRef"
      @selectOk="selectOk"
    ></checked-modal>
  </div>
</template>

<script>
import { getIndustry, saveCreativeLable, queryCreativeLable } from "@/api/promotion.js";
import CheckedModal from "../common/checkedModal.vue";
import { mapState } from "vuex";
export default {
  components: {
    CheckedModal,
  },
  data() {
    return {
      showMore: true,
      curItemId: "",
      dataList: [],
      industryList: [],
      inputTagStr: "",
      tableConf: [
        { title: "创意标签包名称", colName: "creative_name" },
        { title: "创建时间", colName: "createTimeStr" },
      ],
      tableData: [],
    };
  },
  mounted() {
    this.addCreativeClassify();
  },
  methods: {
    saveClassify() {
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      // if (!curItem.industry_id) {
      //   this.$message({
      //     message: "请选择创意分类",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (curItem.ad_keywords.length === 0) {
      //   this.$message({
      //     message: "请添加创意标签",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (curItem.creative_name === "") {
      //   this.$message({
      //     message: "请填写标签包名称",
      //     type: "warning",
      //   });
      //   return;
      // }
      saveCreativeLable({
        industry_id: curItem.industry_id,
        ad_keywords: curItem.ad_keywords,
        creative_name: curItem.creative_name,
      }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: res.msg,
            type: "success",
          });
          curItem.isPackage = true;
        }
      });
    },
    copyToNew() {
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      curItem.isPackage = false;
    },
    checkHasClassify() {
      this.$refs.checkedClassifyModalRef.showModal();
      queryCreativeLable().then((res) => {
        if (res.code === "0000") {
          this.tableData = res.creativeClassifies;
        }
      });
    },
    selectOk(data) {
      data.forEach((item) => {
        this.dataList.push({
          itemId: Math.random(),
          isPackage: true,
          industry_id: item.industry_id,
          ad_keywords: item.ad_keywordsStr.split(","),
          creative_name: item.creative_name,
        });
      });
      this.selectClassifyItem(this.dataList[this.dataList.length - 1]);
    },
    addWrods() {
      let addArr = this.inputTagStr.split(" ");
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      addArr.forEach((item) => {
        if (item && !curItem.ad_keywords.includes(item)) {
          curItem.ad_keywords.push(item);
        }
      });
      this.inputTagStr = "";
    },
    delItem(item) {
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      let delIndex = curItem.ad_keywords.findIndex((dataItem) => dataItem === item);
      curItem.ad_keywords.splice(delIndex, 1);
    },
    clearAll() {
      let curItem = this.dataList.find((item) => item.itemId === this.curItemId);
      curItem.ad_keywords = [];
    },
    initOptions() {
      getIndustry().then((res) => {
        if (res.code === "0000") {
          this.industryList = res.industries;
          this.fillStoreData();
        }
      });
    },
    addCreativeClassify() {
      if (this.dataList.length >= 20) {
        return;
      }
      let randomId = Math.random();
      this.dataList.push({
        itemId: randomId,
        isPackage: false,
        industry_id: null,
        ad_keywords: [],
        creative_name: "",
      });
      this.curItemId = randomId;
    },
    selectClassifyItem(data) {
      this.curItemId = data.itemId;
    },
    handleCommand(item, type) {
      if (type === "del") {
        let delIndex = this.dataList.findIndex((dataItem) => dataItem.itemId === item.itemId);
        this.dataList.splice(delIndex, 1);
        this.curItemId = this.dataList[0].itemId;
      } else if (type === "copy") {
        if (this.dataList.length >= 20) {
          return;
        }
        let copyItem = JSON.parse(JSON.stringify(item));
        let itemId = Math.random();
        copyItem.itemId = itemId;
        this.dataList.push(copyItem);
        this.curItemId = itemId;
      }
    },
    saveInStore() {
      let storeData = this.dataList.map((item) => {
        return {
          industry_id: item.industry_id,
          ad_keywords: item.ad_keywords,
          creative_name: item.creative_name,
        };
      });
      this.$store.commit("set_creative_category", storeData);
    },
    //store中有数据时填充数据
    fillStoreData() {
      if (this.creative_category) {
        this.curItemId = "";
        this.dataList = this.creative_category.map((item) => {
          return {
            ad_keywords: item.ad_keywords,
            creative_name: item.creative_name || "",
            industry_id: item.industry_id,
            isPackage: false,
            itemId: Math.random(),
          };
        });
        this.curItemId = this.dataList[0].itemId;
      }
    },
  },
  computed: {
    ...mapState({
      creative_category: (state) => state.Promotion.draft_ad.creative_category,
    }),
    curClassifyItem() {
      if (this.curItemId) {
        return this.dataList.find((item) => item.itemId === this.curItemId);
      } else {
        return {
          itemId: "",
          isPackage: false,
          industry_id: null,
          ad_keywords: [],
          creative_name: "",
        };
      }
    },
    showList() {
      if (!this.showMore) {
        return this.dataList.slice(0, 3);
      }
      return this.dataList;
    },
  },
};
</script>

<style lang="less" scoped>
.item-card {
  background-color: #fff;
  padding: 24px;
  margin-bottom: 0px !important;
  .card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 84px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .list-wrap {
            .data-list {
              padding: 0px;
              margin: 0px;
              list-style: none;
              .add-btn {
                border-radius: 2px;
                border: 1px solid rgba(24, 144, 255, 1);
                box-sizing: border-box;
                background: rgba(255, 255, 255, 1);
                color: rgba(24, 144, 255, 1);
                margin: 0 14px 12px 0px;
              }
              .data-item {
                display: inline-block;
                border-radius: 2px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                padding: 6px 8px;
                color: rgba(0, 0, 0, 0.85);
                font-size: 14px;
                margin: 0 14px 12px 0px;
                cursor: pointer;
                user-select: none;
                .dot-icon {
                  transform: rotate(90deg);
                  color: #666;
                }
                &.cur {
                  border: 1px solid rgba(24, 144, 255, 1);
                  color: rgba(24, 144, 255, 1);
                  .dot-icon {
                    color: rgba(24, 144, 255, 1);
                  }
                }
              }
            }
            .list-footer {
              display: flex;
              justify-content: space-between;
              .list-length {
                color: rgba(0, 0, 0, 0.85);
                font-size: 14px;
              }
              .show-more {
                color: rgba(24, 144, 255, 1);
                font-size: 13px;
                cursor: pointer;
                margin-left: 20px;
                line-height: 24px;
                i {
                  margin-left: 4px;
                }
              }
            }
          }
          .tag-wrap {
            .tag-header {
              display: flex;
              align-items: center;
              .input-btn {
                color: rgba(24, 144, 255, 1);
                font-size: 14px;
                cursor: pointer;
              }
            }
            .tag-table {
              margin-top: 8px;
              .table-item {
                width: 80%;
                border-radius: 2px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                .table-header {
                  display: flex;
                  background: rgba(0, 0, 0, 0.02);
                  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                  justify-content: space-between;
                  .header-text {
                    display: inline-block;
                    width: 33.3%;
                    text-align: center;
                    padding: 12px 0;
                    color: rgba(0, 0, 0, 0.85);
                    font-size: 14px;
                  }
                }
                .table-content {
                  height: 150px;
                  overflow: auto;
                  padding: 8px;
                  .content-item {
                    height: 22px;
                    line-height: 22px;
                    border-radius: 2px;
                    display: inline-block;
                    padding: 0 8px;
                    margin: 0 8px 8px 0;
                    background: rgba(233, 233, 233, 0.6);
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    .close-btn {
                      display: inline-block;
                      margin-left: 6px;
                      font-size: 18px;
                      cursor: pointer;
                      position: relative;
                      top: 1px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
